/**
 * @generated SignedSource<<c402fb1fd95bc1e95b501749101ff8fc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$data = {
  readonly id: string;
  readonly number: number | null | undefined;
  readonly " $fragmentType": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView";
};
export type storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$key = {
  readonly " $data"?: storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "storyPointEstimate_issueFieldStoryPointEstimateReadviewFull_StoryPointEstimateReadView",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "number"
    }
  ],
  "type": "JiraNumberField"
};

(node as any).hash = "23757b8b917d47b2444d3b2414b283dc";

export default node;
